import { Link } from "react-router-dom";

function Navbar() {
	return (
		<div className="text-slate-950 font-bold flex justify-between h-[80px] shadow-lg">
			<div className="flex items-center justify-start">
				<a href="/" className="text-xl font-bold sm:basis-1/2 ps-5 ">
					<img src="/asset/telemixLogo.png" className="w-[400px]" alt="" />
				</a>
			</div>
			<div className="bg-amber-600 bg-opacity-50 basis-1/2 text-xl flex justify-end items-center space-x-3 pe-5">
				<Link to="/" className="hover:text-yellow-800">
					Home
				</Link>
				<Link to="/about" className="hover:text-yellow-800">
					About
				</Link>
				<Link to="/services" className="hover:text-yellow-800">
					Services
				</Link>
				<Link to="/contact" className="hover:text-yellow-800">
					Contact
				</Link>
			</div>
		</div>
	);
}

export default Navbar;
